import { ChangeEvent, FC, JSX } from 'react';
import { Slider } from '@mui/material';
import { IMinAppProps } from '@interfaces/App.interface';
import { ICreateWarningRule } from '@ts/ui-models';
import { Grid, TextInput, Typography } from '@ts/storybook';

interface WarningRuleStep3Props extends IMinAppProps {
  formData: ICreateWarningRule;
  setFormData: (attr: string) => (event: ChangeEvent | null, value: string | number | number[] | null) => void;
  requiredFields: string[];
  isPreview?: boolean;
}

const DEFAULT_MIN_SEVERITY = 1;
const DEFAULT_MAX_SEVERITY = 15;

const WarningRuleStep3: FC<WarningRuleStep3Props> = props => {
  /*  const previewContent = useCheckPreview<ICreateWarningRule>(props.formData, ['assigneeId'], props.isPreview);

  if (previewContent) {
    return previewContent;
  } */

  //#region Render
  const renderPropSliderText = (): JSX.Element => {
    const listProps = [
      { field: 'ackCheck', text: 'Time in minutes and severity increase for the acknowledgement check' },
      { field: 'resolveCheck', text: 'Time in minutes and severity increase for the resolution check' },
      { field: 'closeCheck', text: 'Time in minutes and severity increase for the closure check' },
    ];

    return (
      <>
        {listProps.map(lp => (
          <Grid key={lp.field} container spacing={4} size={{ xs: 12, md: 8 }}>
            <Grid size={{ xs: 12 }}>
              <Typography gutterBottom text={[lp.text]} />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextInput
                type="number"
                value={props.formData[lp.field]?.mins}
                onChange={(e, v) => props.setFormData([lp.field] + '.mins')(null, v)}
                isReadOnly={props.isPreview}
                InputProps={{
                  endAdornment: <div style={{ marginLeft: '5px' }}>mins</div>,
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} sx={{ paddingTop: '8px!important' }}>
              <Typography gutterBottom text={['Increment', ': ', props.formData[lp.field]?.severityIncrease.toString()]} />
              <Slider
                value={props.formData[lp.field]?.severityIncrease}
                onChange={(e, v) => props.setFormData([lp.field] + '.severityIncrease')(null, v)}
                min={0}
                max={DEFAULT_MAX_SEVERITY}
                marks
                disabled={props.isPreview}
              />
            </Grid>
          </Grid>
        ))}
      </>
    );
  };
  //#endregion

  return (
    <Grid container spacing={2} justifyContent="flex-start">
      <Grid size={{ xs: 12 }}>
        {!props.isPreview && <Typography variant="h6" gutterBottom text="Severity" />}
        <Typography gutterBottom text={['Minimum', ': ', props.formData.minSeverity.toString()]} />
        <Grid size={{ xs: 12, md: 4 }}>
          <Slider
            value={props.formData.minSeverity}
            onChange={(e, v) => props.setFormData('minSeverity')(null, v)}
            min={DEFAULT_MIN_SEVERITY}
            max={DEFAULT_MAX_SEVERITY}
            marks
            disabled={props.isPreview}
          />
        </Grid>
        <Typography gutterBottom text={['Maximum', ': ', props.formData.maxSeverity.toString()]} />
        <Grid size={{ xs: 12, md: 4 }}>
          <Slider
            value={props.formData.maxSeverity}
            onChange={(e, v) => props.setFormData('maxSeverity')(null, v)}
            min={DEFAULT_MIN_SEVERITY}
            max={DEFAULT_MAX_SEVERITY}
            marks
            disabled={props.isPreview}
          />
        </Grid>
      </Grid>
      {renderPropSliderText()}
    </Grid>
  );
};
export default WarningRuleStep3;
